import { Component, Input, OnInit } from '@angular/core'
import { ResourcePolicyDeniedIssue } from 'src/app/account/services/issue'
import { UiService } from 'src/app/services/ui.service'
import { ViewableIssue } from '../../issues-view/issues-view.component'

@Component({
  selector: 'resource-policy-permission-issue',
  templateUrl: './resource-policy-permission-issue.component.html',
  styleUrls: ['./resource-policy-permission-issue.component.scss'],
  standalone: false,
})
export class ResourcePolicyPermissionIssueComponent implements OnInit {
  @Input() issue: ResourcePolicyDeniedIssue = null
  @Input() viewableIssue: ViewableIssue = null

  constructor(public uiService: UiService) {}

  ngOnInit() {}
}
